/* @flow */

import { compose } from 'ramda';
import { createUseStyles } from 'react-jss';
import * as React from 'react';

import styles from './AuthenticationBase.style';
import Markdown from 'src/shared/app/base/component/text/Markdown';
import InstructionText from 'src/shared/ui/component/text/InstructionText';

type Props = {
  id: string,
  withError?: boolean,
  children: React.Node,
};

const useStyles = createUseStyles(styles);

const AuthenticationFormHeader = ({
  id,
  withError,
  children,
}: Props): React.Node => {
  const classes: Object = useStyles();

  return (
    <header
      className={classes.header}
      id={id || null}
      aria-live={withError ? 'assertive' : ''}
    >
      <InstructionText withError={withError}>
        <Markdown>{children || ''}</Markdown>
      </InstructionText>
    </header>
  );
};

export default compose(React.memo)(AuthenticationFormHeader);
